// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Form__Radio = require("../../../uikit/reason/atoms/Form/Form__Radio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayKeyFactsDraftType_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsDraftType_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsDraftType_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsDraftType_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsDraftType_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__DraftType(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment, props.draft);
  let update = PropertyWizardFormRelay.useUpdateDraftProperty();
  let propertyType = draft.draftProperty.propertyType;
  return JsxRuntime.jsx(FormV5.FormSection.make, {
    children: JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
      children: JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        children: JsxRuntime.jsx(ViewStack.make, {
          flexDirection: "column",
          children: JsxRuntime.jsx(Form__Radio.RadioList.make, {
            selected: propertyType,
            items: [
              {
                label: "For Sale",
                value: "FOR_SALE"
              },
              {
                label: "Rental",
                value: "RENTAL"
              }
            ],
            name: "listingType",
            toValue: v => v,
            onChange: v => update(c => {
              let newrecord = {...c};
              newrecord.propertyType = v;
              return newrecord;
            })
          })
        })
      })
    })
  });
}

let Components;

let FormSection;

let Grid;

let Cell;

let make = PropertyWizardRelay__KeyFacts__DraftType;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Grid = Grid;
exports.Cell = Cell;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
